var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 1.95831C5.28301 1.95831 1.45801 5.78331 1.45801 10.5C1.45801 15.2166 5.28301 19.0416 9.99967 19.0416C14.7163 19.0416 18.5413 15.2166 18.5413 10.5C18.5413 5.78331 14.7163 1.95831 9.99967 1.95831ZM15.3663 8.03331L9.36634 14.5083C9.26634 14.6166 9.12467 14.675 8.98301 14.6833H8.97468C8.83301 14.6833 8.69968 14.625 8.59134 14.525L4.64967 10.5833C4.44134 10.375 4.44134 10.0333 4.64967 9.82498C4.85801 9.61665 5.19967 9.61665 5.40801 9.82498L8.94967 13.3666L14.5747 7.29998C14.7747 7.08331 15.1163 7.06665 15.333 7.27498C15.5497 7.47498 15.5663 7.81665 15.358 8.03331H15.3663Z",
    fill: "#009629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoSuccess);
export default __webpack_public_path__ + "static/media/icon-info-success.3573a76a1de507be2a5e921bbbac848d.svg";
export { ForwardRef as ReactComponent };